<template>
  <!-- ok-button-props 実行済のデータは保存できない  -->
  <a-modal
    :title="title"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :centered="true"
    :width="'calc(100vw - 16px)'"
  >
    <div @click="freeMenuCancel">
      <a-spin :spinning="loading">
        <div class="table-page-search-wrapper" style="padding: 0 20px">
          <a-form :form="form" layout="inline">
            <a-row :gutter="24">
              <a-col :xs="1" :sm="1" style="width: 750px">
                <a-form-item
                  :label="$t('disp.action.executeTime')"
                  style="margin-bottom: 0; width: auto; display: inline-block"
                >
                  <!-- 実行時間を計画 -->
                  <a-date-picker
                    dropdownClassName="action-executeTime"
                    :placeholder="$t('disp.ph.select', [$t('disp.action.executeTime')])"
                    style="width: 280px"
                    v-decorator="['executeTime', validatorRules.executeTime]"
                    :disabled-date="disabledDate"
                    :disabled="executeDisabled"
                  />
                </a-form-item>
                <a-button
                  icon="undo"
                  type="primary"
                  style="margin-left: 24px"
                  :disabled="executeDisabled"
                  @click="handleRevoke"
                  >{{ $t('disp.btn.revoke') }}</a-button
                >
                <a-button icon="history" @click="handleHistory">{{ $t('disp.flow.history') }}</a-button>
              </a-col>

              <a-col :sm="24" :md="12" :lg="12" :xl="8" :xxl="8" v-show="false">
                <a-form-item :label="$t('disp.action.changeDiv')">
                  <!-- Actionタイプ -->
                  <j-dict-select-tag
                    v-decorator="['changeDiv', validatorRules.changeDiv]"
                    dictCode="action_type"
                    :triggerChange="true"
                    :disabled="true"
                    @change="handleChange"
                    :placeholder="$t('disp.ph.select', [$t('disp.action.changeDiv')])"
                  /> </a-form-item
              ></a-col>

              <a-col :sm="24" :md="12" :lg="12" :xl="8" :xxl="8" v-show="false">
                <a-form-item :label="$t('disp.note')">
                  <!-- Action内容 -->
                  <a-input
                    :placeholder="$t('disp.ph.input', [$t('disp.note')])"
                    v-model="model.memo"
                    :maxLength="100"
                    :disabled="true"
                  /> </a-form-item
              ></a-col>
            </a-row>
          </a-form>
        </div>

        <!-- Action対応component -->
        <a-collapse v-model="activeKey" class="a-collapse-main" bordered>
          <a-collapse-panel key="1" :header="$t('disp.action.detail')" :forceRender="true">
            <component
              v-if="src"
              v-bind:is="src"
              v-bind="$attrs"
              ref="ModalForm"
              @handleCancel="handleCancel"
            ></component>
            <a-empty v-else></a-empty>
          </a-collapse-panel>
        </a-collapse>
      </a-spin>
      <div style="position: absolute; top: 0px; left: 0px; width: 100%" v-show="!executeDisabled">
        <div>
          <div class="ant-dropdown" id="freemenu" style="left: 0px; top: 0px; display: none">
            <ul
              class="
                ant-dropdown-menu
                ant-dropdown-menu-vertical
                ant-dropdown-menu-root
                ant-dropdown-menu-light
                ant-dropdown-content
              "
            >
              <li @click="handleMarge" class="ant-dropdown-menu-item">{{ $t('disp.tree.marge') }}</li>
              <li @click="handleChangeChild" class="ant-dropdown-menu-item">{{ $t('disp.tree.changeChild') }}</li>
              <li @click="freeMenuCancel" class="ant-dropdown-menu-item">{{ $t('disp.btn.cancel') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <template slot="footer">
      <a-button type="primary" v-if="!executeDisabled && src" @click="handleOk" icon="check">{{
        $t('disp.btn.confirm')
      }}</a-button>
      <a-button type="primary" v-if="executeDisabled || !src" @click="handleCancel">{{
        $t('disp.btn.close')
      }}</a-button>
    </template>
  </a-modal>
</template>
<script>
import pick from 'lodash/pick'
import { httpAction, getAction } from '@/api/manage'
import { duplicateCheck } from '@/api/api'

export default {
  name: 'ActionModal',
  components: {},
  data() {
    return {
      src: '',
      components: {
        // 組織変更
        departAllChange: 'views/k00/k0015/modules/DepartAllChange',
      },
      visible: false,
      activeKey: ['1'],
      // 组织变更主键
      changePlanId: '',
      // タイプ無効かflg
      typeDisabled: false,
      // タイプ無効かflgは実行済み
      executeDisabled: false,
      // 取り消しボタンの表示/非表示 flg
      revokeBtnShow: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      colSpan: 24,
      model: {},
      loading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        changeDiv: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
        executeTime: { rules: [{ required: true, message: this.$t('disp.rules.require') }] },
      },
      url: {
        createDepartAction: '/blaze-sys/k00/k0015/DepartAction/createDepartAction',
      },
    }
  },
  methods: {
    add() {
      this.edit({})
      // 默认加载组织变更
      this.handleChange('departAllChange')
      this.typeDisabled = false
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      this.visible = true
      this.typeDisabled = true
      this.executeDisabled = this.model.isExecute == '1'

      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model, 'changeDiv'))

        // 計画実行時間をセット
        this.form.setFieldsValue({
          executeTime: this.model.executeTime ? moment(this.model.executeTime).format('YYYY-MM-DD') : null,
        })

        if (this.model.changeDiv != null) {
          // ActionTypeによりコンポーネントを切り替え
          this.src = require('@/' + this.components[this.model.changeDiv]).default
          var targetTableKey = this.model.targetTableKey
          var sourceTableKey = this.model.sourceTableKey
          var executeDisabled = this.executeDisabled

          var that = this
          if (that.model.changeDiv == 'departAllChange') {
            // 組織変更操作の場合
            // 取り消しボタンの表示/非表示
            that.revokeBtnShow = true
            // コンポーネントの切り替えは閉じるまで。サブコンポーネントの実行を遅延し、コンポーネントは加载中の場合、ファンクション使用できない
            var interval = setInterval(() => {
              if (that.$refs.ModalForm) {
                window.clearInterval(interval)
                that.$refs.ModalForm.load(that.model.id, executeDisabled)
              }
            }, 100)
          } else {
            // 組織変更操作ではない場合
            // 取り消しボタンの表示/非表示
            that.revokeBtnShow = false
            // コンポーネントの切り替え。サブコンポーネントの実行を遅延し、コンポーネントは加载中の場合、ファンクション使用できない
            var interval = setInterval(() => {
              window.clearInterval(interval)
              that.$refs.ModalForm.edit(sourceTableKey, targetTableKey, executeDisabled)
            }, 100)
          }
        } else {
        }
      })
    },
    close() {
      var that = this

      getAction('/blaze-sys/k00/k0015/DepartAction/getHistory?changePlanId=' + this.changePlanId, null).then((res) => {
        if (res.success) {
          if (this.typeDisabled == false && this.$refs.ModalForm.addSaveFlag == false && res.result.length > 0) {
            this.$confirm({
              title: that.$t('disp.action.confirm.cancelEdit'),
              content: (h) => <div style="color:red;">{that.$t('disp.flow.withoutSave')}</div>,
              onOk() {
                // 顺便利用一下清空临时数据的功能
                getAction('/blaze-sys/k00/k0015/DepartAction/getHistory?forceClear=true&changePlanId=' + that.changePlanId, null)

                that.$emit('close')
                that.visible = false
                that.src = ''
              },
              onCancel() {},
            })
          } else {
            if (res.result.length == 0) {
              // 顺便利用一下清空临时数据的功能
              getAction('/blaze-sys/k00/k0015/DepartAction/getHistory?forceClear=true&changePlanId=' + that.changePlanId, null)
            }

            that.$emit('close')
            that.visible = false
            that.src = ''
          }
        }
      })
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      // フォーム検証をトリガー
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          // メインデータフォーム
          let dataAction = Object.assign(this.model, values)

          // Actionフォーム
          this.$refs.ModalForm.handleOk(dataAction).then((res) => {
            if (!res) {
              this.loading = false
            }
          })
        } else {
          this.loading = false
        }
      })
    },
    handleCancel() {
      this.loading = false
      this.$emit('searchQuery')
      this.close()
    },
    // 取り消し
    handleRevoke() {
      this.$refs.ModalForm.handleRevoke()
    },
    // 履历
    handleHistory() {
      this.$refs.ModalForm.handleHistory()
    },
    // ActionTypeで組織切り替え
    handleChange(value) {
      if (value) {
        this.colSpan = 8
        this.labelCol = { span: 7 }
        this.wrapperCol = { span: 17 }

        if (value == 'departAllChange') {
          this.loading = true
          // 組織変更操作の場合
          // 取り消しボタンの表示/非表示
          this.revokeBtnShow = true
          // メインデータフォーム
          let dataAction = this.form.getFieldsValue()
          dataAction.changeDiv = value
          httpAction(this.url.createDepartAction, dataAction, 'post').then((res) => {
            if (res.success) {
              this.src = require('@/' + this.components[value]).default

              // コンポーネントの切り替え。サブコンポーネントの実行を遅延し、コンポーネントは加载中の場合、ファンクション使用できない
              var interval = setInterval(() => {
                window.clearInterval(interval)
                this.changePlanId = res.result.id
                this.$refs.ModalForm.load(res.result.id, false)
                this.loading = false
              }, 100)
            }
          })
        } else {
          // 組織変更操作ではない場合
          // 取り消しボタンの表示/非表示
          this.revokeBtnShow = false
          this.src = require('@/' + this.components[value]).default

          // コンポーネントの切り替え。サブコンポーネントの実行を遅延し、コンポーネントは加载中の場合、ファンクション使用できない
          var interval = setInterval(() => {
            window.clearInterval(interval)
            this.$refs.ModalForm.add()
          }, 100)
        }
      } else {
        this.src = ''
        this.colSpan = 24
        this.labelCol = { span: 6 }
        this.wrapperCol = { span: 16 }
      }

      this.model.changeDiv = value
    },
    disabledDate(current) {
      return false
      return (current && current <= moment().startOf('day')) || current.format('DD') != '01'
    },
    freeMenuCancel() {
      document.querySelector('#freemenu').style = 'display:none;'
    },
    handleMarge() {
      this.$refs.ModalForm.handleMarge()
    },
    handleChangeChild() {
      this.$refs.ModalForm.handleChangeChild()
    },
  },
}
</script>

<style lang="less" scoped>
.ant-divider-horizontal {
  margin: 24px 0 22px;
}

/deep/ .p-notice {
  position: absolute;
  background: white;
  left: 45%;
  margin-top: -8px;
  z-index: 1;
  width: 100px;
  text-align: center;
  letter-spacing: 5px;
  padding-left: 5px;
}

.a-collapse-main {
  margin-top: 20px;

  /deep/ .ant-collapse-content-box {
    padding: 20px;
  }
}
</style>
<style>
.action-executeTime .ant-calendar-next-month-btn-day:not(.ant-calendar-disabled-cell) .ant-calendar-date {
  color: #000;
}
</style>
